import React, { useState, useRef, useEffect } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css';

import { gql, useMutation } from '@apollo/client';

import ReactMapGL, { GeolocateControl, Marker, NavigationControl } from 'react-map-gl';
import Geocoder from 'react-map-gl-geocoder';
import DeckGL from '@deck.gl/react';
// import { GeoJsonLayer } from '@deck.gl/layers';

import { format } from 'date-fns';
import geo from 'mapbox-geocoding';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import Menu from 'components/ui/Menu';
import { Box, Button, Level, Item } from 'components/ui/bulma';

const token = 'pk.eyJ1IjoiYW5kcmVqczE5NzkiLCJhIjoiY2s4ZXg3M3hxMDBtaDNkbjZwMGl1ZGNkMCJ9.lfRQSV9ls7UYOQgG4zJSSg';

geo.setAccessToken(token);

export default function Map({ user }) {
	const mapRef = useRef();

	const originRef = useRef();
	const destinationRef = useRef();

	const [ step, setStep ] = useState(0);
	const [ finish, setFinish ] = useState();

	const [ origin, setOrigin ] = useState();
	const [ arrival, setArrival ] = useState();

	const [ departure, setDeparture ] = useState();
	const [ destination, setDestination ] = useState();

	const [ email, setEmail ] = useState();

	const [ viewport, setViewport ] = useState({
		latitude: 38.9,
		longitude: -77.04,
		zoom: 11
	});

	const [ createTrip ] = useMutation(CREATE_TRIP);

	useEffect(
		() => {
			if (finish) {
				const tripProps = {
					date: format(Date.now(), 'MM/dd/yyyy HH:mm'),
					originNumber: origin.address,
					originStreet: origin.text,
					originCity: origin.context.find((context) => context.id.includes('place')).text,
					originState: origin.context.find((context) => context.id.includes('region')).text,
					originZIP: origin.context.find((context) => context.id.includes('postcode')).text,
					originCountry: origin.context.find((context) => context.id.includes('country')).text,
					originAddress: origin.place_name,
					originGeo: origin.geometry,
					destinationNumber: destination.address,
					destinationStreet: destination.text,
					destinationCity: destination.context.find((context) => context.id.includes('place')).text,
					destinationState: destination.context.find((context) => context.id.includes('region')).text,
					destinationZIP: destination.context.find((context) => context.id.includes('postcode')).text,
					destinationCountry: destination.context.find((context) => context.id.includes('country')).text,
					destinationAddress: destination.place_name,
					destinationGeo: destination.geometry,
					arriveBy: arrival,
					departAt: departure,
					email
				};

				try {
					createTrip({ variables: { tripProps } });
				} catch (error) {
					console.log(error);
				}
			}
		},
		[ origin, destination, departure, arrival, email, finish, createTrip ]
	);

	const handleGeocoderViewportChange = (viewport) => {
		const geocoderDefaultOverrides = { transitionDuration: 1000 };

		const newViewport = {
			...viewport,
			latitude: viewport.latitude - 0.001
		};

		return handleViewportChange({
			...newViewport,
			...geocoderDefaultOverrides
		});
	};

	const handleViewportChange = (viewport) => {
		setViewport({ ...viewport });
	};

	return (
		<div style={{ height: '100vh' }}>
			<div className="columns is-mobile is-centered is-gapless">
				<div
					className="column is-clipped is-12-mobile is-12-touch is-5-tablet is-3-desktop"
					style={{
						justifyContent: 'center',
						alignItems: 'center',
						position: 'absolute',
						bottom: '50px',
						zIndex: 50
					}}
				>
					{!finish &&
					step === 0 && (
						<div className="box has-background-white has-text-centered">
							<p className="title is-size-5 has-text-centered">
								{origin ? origin.place_name : 'Please type your home address'}
							</p>
							<Level mobile>
								<Item>
									<div ref={originRef} />
									<div style={{ marginLeft: 5 }}>
										<GeolocateControl
											mapRef={mapRef}
											positionOptions={{ enableHighAccuracy: true }}
											trackUserLocation={true}
										/>
									</div>
								</Item>
							</Level>

							<div className="select is-light is-fullwidth" style={{ display: 'inline-block' }}>
								<select value={arrival} onChange={({ target }) => setArrival(target.value)}>
									<option value={null}>Arrive to work by...</option>
									<option value="07:00:00">7.00 a.m.</option>
									<option value="07:30:00">7.30 a.m.</option>
									<option value="08:00:00">08.00 a.m.</option>
									<option value="08:30:00">08.30 a.m.</option>
									<option value="09:00:00">09.00 a.m.</option>
									<option value="09:30:00">09.30 a.m.</option>
									<option value="10:00:00">10.00 a.m.</option>
								</select>
							</div>
							<br />
							<br />
							<Button
								block
								size="medium"
								icon="check-circle"
								disabled={!origin || !arrival}
								action={() => setStep(1)}
							>
								Continue
							</Button>
						</div>
					)}
					{!finish &&
					step === 1 && (
						<div className="box has-background-white has-text-centered">
							<p className="title is-size-5 has-text-centered">
								{' '}
								{destination ? destination.place_name : 'Please type your work address'}
							</p>
							<Level mobile>
								<Item>
									<div ref={destinationRef} />
									<div style={{ marginLeft: 5 }}>
										<GeolocateControl
											mapRef={mapRef}
											positionOptions={{ enableHighAccuracy: true }}
											trackUserLocation={true}
										/>
									</div>
								</Item>
							</Level>

							<div className="select is-light is-fullwidth" style={{ display: 'inline-block' }}>
								<select value={departure} onChange={({ target }) => setDeparture(target.value)}>
									<option value={null}>Going home at...</option>
									<option value="15:00:00">3.00 p.m.</option>
									<option value="15:30:00">3.30 p.m.</option>
									<option value="16:00:00">4.00 p.m.</option>
									<option value="16:30:00">4.30 p.m.</option>
									<option value="17:00:00">5.00 p.m.</option>
									<option value="17:30:00">5.30 p.m.</option>
									<option value="18:00:00">6.00 p.m.</option>
									<option value="18:30:00">6.30 p.m.</option>
									<option value="19:00:00">7.00 p.m.</option>
								</select>
							</div>
							<br />
							<br />
							<Button
								block
								size="medium"
								icon="check-circle"
								disabled={!destination || !departure}
								action={() => setStep(2)}
							>
								Continue
							</Button>
						</div>
					)}
					{!finish &&
					step === 2 && (
						<div className="box has-background-white has-text-centered">
							<p className="title is-size-5 has-text-centered">Please enter your email</p>
							<div className="field">
								<div className="control">
									<input
										className="input"
										type="text"
										placeholder="Your email"
										onChange={({ target }) => setEmail(target.value)}
									/>
								</div>
							</div>
							<Button
								block
								size="medium"
								icon="check-circle"
								disabled={!email}
								action={() => setFinish(true)}
							>
								Finish
							</Button>
						</div>
					)}
					{finish && (
						<div className="box has-background-white has-text-centered">
							<FontAwesomeIcon icon="check-circle" size="5x" color="#008080" />
							<br />
							<br />
							<p className="title is-size-5 has-text-centered">Thank you!</p>
							<p className="subtitle is-size-5 has-text-centered">
								We will contact you about your trip shortly.
							</p>
						</div>
					)}
				</div>
			</div>
			<DeckGL
				initialViewState={{ ...viewport }}
				controller={true}
				onClick={(info, allInfos, event) =>
					geo.reverseGeocode('mapbox.places', info.lngLat[0], info.lngLat[1], (err, location) => {
						if (step === 0) setOrigin(location.features[0]);
						if (step === 1) setDestination(location.features[0]);
					})}
			>
				<ReactMapGL
					ref={mapRef}
					mapStyle="mapbox://styles/andrejs1979/ck8gin8zl09us1ioih7tkmcpi"
					mapboxApiAccessToken={token}
					clickRadius={2}
				>
					{/* <div style={{ position: 'absolute', left: 20, top: 20 }}>
						<NavigationControl />
					</div> */}
					{!finish &&
					step === 0 && (
						<Geocoder
							mapRef={mapRef}
							containerRef={originRef}
							onResult={({ result }) => setOrigin(result)}
							onViewportChange={handleGeocoderViewportChange}
							mapboxApiAccessToken={token}
							countries="us"
							limit={3}
						/>
					)}
					{!finish &&
					step === 1 && (
						<Geocoder
							mapRef={mapRef}
							containerRef={destinationRef}
							onResult={({ result }) => setDestination(result)}
							onViewportChange={handleGeocoderViewportChange}
							mapboxApiAccessToken={token}
							countries="us"
							limit={3}
						/>
					)}

					{origin && (
						<Marker latitude={origin.center[1]} longitude={origin.center[0]}>
							<Box>
								<FontAwesomeIcon icon="home" size="2x" color="#000" />
							</Box>
						</Marker>
					)}
					{destination && (
						<Marker latitude={destination.center[1]} longitude={destination.center[0]}>
							<Box>
								<FontAwesomeIcon icon="building" size="2x" color="#000" />
							</Box>
						</Marker>
					)}
				</ReactMapGL>
			</DeckGL>
		</div>
	);
}

const CREATE_TRIP = gql`
	mutation CreateTrip($tripProps: TripProps) {
		createTrip(tripProps: $tripProps) {
			id
		}
	}
`;
